import { EntitySelectorsFactory } from '@ngrx/data';
import { createSelector } from '@ngrx/store';
import { CheckItem, createCheckItem } from '@rpe/registro-personas-empresas-lib';
import { selectLaboratorioById } from '../entity-laboratorios/laboratorios.selectors';
import { selectAllTiposEquipamientoLaboratorio } from '../entity-tipos-equipamiento-laboratorio/tipos-equipamiento-laboratorio.selectors';

import { EquipamientoLaboratorio } from './equipamientos-laboratorio.model';

export const equipamientoLaboratorioSelectors =
  new EntitySelectorsFactory().create<EquipamientoLaboratorio>('EquipamientoLaboratorio');

export const selectAllEquipamientosLaboratorios =
  equipamientoLaboratorioSelectors.selectEntities;

// Se retornar los equipamientos con los tipos en checklist del laboratorio
export const selectEquipamientosLaboratorioCheckList = (laboratorioId: number) => createSelector(
  selectLaboratorioById(laboratorioId),
  selectAllTiposEquipamientoLaboratorio,
  (laboratorio, tiposEquipamientoLaboratorio) => {
    tiposEquipamientoLaboratorio = tiposEquipamientoLaboratorio.filter((te) => te.publico || (laboratorio ? laboratorio.equipamientos.find(e => e.tipo_equipamiento_laboratorio_id == te.id) : false))

    let lCheckItem: CheckItem[] = [];

    if (laboratorio) {
      tiposEquipamientoLaboratorio.forEach(tel => {
        const existeTDM = laboratorio.equipamientos.find(e => e.tipo_equipamiento_laboratorio_id == tel.id);
        const ci = createCheckItem({ id: existeTDM ? existeTDM.id : null, tipo_id: tel.id, nombre: tel.nombre, selected: existeTDM ? true : false })
        lCheckItem.push(ci)
      })
    } else {
      tiposEquipamientoLaboratorio.forEach(tel => {
        const ci = createCheckItem({ id: null, tipo_id: tel.id, nombre: tel.nombre, selected: false })
        lCheckItem.push(ci)
      })
    }

    const orderMap: { [key: string]: number } = {
      "Descascaradora": 1,
      "Descuscutadora": 2,
      "Estufa": 3,
      "Lupa de mesa con iluminación": 4,
      "Microscopio estereoscópico o lupa binocular": 5,
      "Zarandas": 6
    };    

    lCheckItem.sort((a, b) => orderMap[a.nombre] - orderMap[b.nombre]);

    return lCheckItem
  }
);

